import { SVGProps } from "react";

export const ConfluenceMarkBrandV2 = ({
    width = "100%",
    height = "100%"
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Container">
            <path
                id="Vector"
                d="M5.10887 21.6946C4.89371 22.0739 4.60682 22.4877 4.39165 22.8325C4.17648 23.1428 4.28407 23.5566 4.64268 23.7635L9.30464 26.5221C9.66325 26.729 10.0936 26.6256 10.3088 26.2808C10.4881 25.9704 10.7391 25.5911 10.9901 25.1773C12.8549 22.2463 14.6838 22.5911 18.0548 24.1428L22.6809 26.2463C23.0395 26.4187 23.4698 26.2463 23.6491 25.9015L25.8725 21.0739C26.016 20.729 25.8725 20.3152 25.5139 20.1773C24.5457 19.729 22.6092 18.867 20.852 18.0394C14.5404 15.1428 9.19706 15.3152 5.10887 21.6946Z"
                fill="#1868DB"
            />
            <path
                id="Vector_2"
                d="M26.0162 10.7638C26.2313 10.3845 26.5182 9.97072 26.7334 9.62589C26.9486 9.31554 26.841 8.90175 26.4824 8.69485L21.8204 5.93623C21.4618 5.72934 21.0315 5.83279 20.8163 6.17761C20.637 6.48796 20.386 6.86727 20.1349 7.28106C18.2701 10.2121 16.4412 9.86727 13.0703 8.31554L8.48002 6.17761C8.12141 6.0052 7.69107 6.17761 7.51177 6.52244L5.28837 11.35C5.14492 11.6949 5.28837 12.1086 5.64698 12.2466C6.61523 12.6949 8.55174 13.5569 10.3089 14.3845C16.5847 17.3155 21.928 17.1431 26.0162 10.7638Z"
                fill="#1868DB"
            />
        </g>
    </svg>
);
